
import { defineComponent, onMounted } from 'vue';
import { useLoadingSsr } from 'PortalDir/common/composables/useLoadingSsr';

export default defineComponent({
  name: 'TheContainer',
  setup() {
    const { isLoading } = useLoadingSsr();

    // const showLoading = computed(() => loadingStore.getLoading);
    const showLoading = false;

    onMounted(async () => {
      isLoading.value = false;
    });

    function ssrHeight(offset, height) {
      if (offset === 50 && height === 0) {
        // ВАЖНО 520px = 440px футер + 80px хедер, для SSR чтоб не скакало все
        return { minHeight: 'calc(100vh - 520px)' };
      }
      return { minHeight: offset ? `calc(100vh - ${offset}px)` : '100vh' };
    }
    return {
      showLoading,
      ssrHeight,
      isLoading,
    };
  },
});
